import { FC, useEffect, useRef } from "react";
import s from "./ModalServerOffline.module.scss";
import { CloseIcon } from "../../../assets/svg/CloseIcon";

type ModalServerOfflineT = {
  closeFunc: any;
};

export const ModalServerOffline: FC<ModalServerOfflineT> = ({ ...props }) => {
  const { closeFunc } = props;
  const wrapperRef: any = useRef(null);

  useEffect(() => {
    const handleClickOutside =
      (wrapperRef: any, closeFunc: any) => (event: any) => {
        if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
          closeFunc();
        }
      };
    document.addEventListener(
      "mousedown",
      handleClickOutside(wrapperRef, closeFunc)
    );
    return () => {
      document.removeEventListener(
        "mousedown",
        handleClickOutside(wrapperRef, closeFunc)
      );
    };
  }, [wrapperRef]);
  //@ts-ignore

  return (
    <div className={s.wrapper} ref={wrapperRef}>
      <div className={s.head}>
        <span></span>
        <div className={s.close} onClick={closeFunc}>
          <CloseIcon />
        </div>
      </div>
      <div className={s.title}>Oops!</div>
      <div className={s.subtitle}>
        The server is currently offline, so we can't show the image right now.
        Please try again later.
      </div>
      <div className={s.reload} onClick={() => closeFunc()}>
        Ok
      </div>
    </div>
  );
};
